module.exports = __webpack_public_path__ + "img/dakai.6ac4698c.png";